module.exports = __webpack_public_path__ + "static/media/Linkedin.f9ed8326.png";